module.exports = __webpack_public_path__ + "static/media/uottawa.7ecae964.jpg";